// 用于在聊天页和成员选择页之间共享 @mention 选择状态
const atCtx = {
  atStart: -1,      // @ 在 inputValue 中的位置
  atEnd: -1,        // 跳转时光标位置（= atStart + 1）
  inputValue: '',   // 跳转时的输入框内容
  result: null,     // { nick, accountId } —— 由 TeamMembers 页写入
};

export default atCtx;
